import * as R from 'ramda';
import { ONLY_NUMBERS } from './regexp';

export const getMaxFieldLengthRule = (maxLength, message) => ({
  max: maxLength,
  message: message || `The maximum length of ${maxLength} characters exceeded`,
});

export const filterOption = (input, option) =>
  R.is(Array, option.props.children)
    ? option.props.children[1].toLowerCase().indexOf(input.trim().toLowerCase()) >= 0
    : option.props.children.toLowerCase().indexOf(input.trim().toLowerCase()) >= 0;

/**
 * @param rules: array
 * @returns {{rules}}
 */
export const validatePassword = (rules = []) => ({
  rules: [
    {
      pattern: /^[\w]{0,8}$|([\w]|[^\w]){8,}/,
      message: 'Password must be at least 8 characters and must not contain any special characters!',
    },
    {
      pattern: /[\w]{8,}|[^\w]/,
      message: 'Password must be at least 8 characters long!',
    },
    {
      pattern: /^([\w]|[^\w]){0,7}$|^[\w]*$/,
      message: 'Password must not contain any special characters!',
    },
    ...rules,
  ],
});

export const validateNumberInput = (value) => {
  if (R.isNil(value)) {
    return 'This field is required!';
  }

  if (!ONLY_NUMBERS.test(value)) {
    return 'This field is not valid!';
  }

  return null;
};

export const validateNumbersRange = (range) => {
  const min = range[0];
  const max = range[1];

  if (R.isNil(min) || R.isNil(max)) {
    return 'These fields are required!';
  }

  if (!ONLY_NUMBERS.test(min) || !ONLY_NUMBERS.test(max)) {
    return 'Fields are not valid!';
  }

  if (+min === +max) {
    return 'The minimum and maximum values are equal!';
  }

  if (+min > +max) {
    return 'The minimum value should not exceed the maximum value!';
  }

  return null;
};

export const checkUnassignedSalesWithoutTasks = ({
  selectedUsers = [], value = [], requestTasks = [], tasks = {}, users = {},
}) => {
  // check if we removing person
  if (value.length < selectedUsers.length) {
    // find agents before and after
    const agentsBefore = selectedUsers.filter(selected => users[selected].role === 'sales-agent').sort();
    const agentsAfter = value.filter(selected => users[selected].role === 'sales-agent').sort();

    // check if any agent was removed
    if (agentsBefore.length > agentsAfter.length) {
      const deletedAgents = agentsBefore.filter(agent => !agentsAfter.includes(agent));

      const deletedAgentsWithoutTask = requestTasks.reduce((accum, task) => {
        const { assignedTo } = tasks[task];
        // remove agent from list if we found at least one task where he assigned
        if (deletedAgents.includes(assignedTo)) {
          return accum.filter(val => val !== tasks[task].assignedTo);
        }
        return accum;
      }, deletedAgents);
      // check if deleted agent had task in current request
      if (deletedAgentsWithoutTask.length) {
        const currentUserId = localStorage.getItem('userId');
        return deletedAgentsWithoutTask
          .map(agent => currentUserId === agent ? 'You' : users[agent].fullName)
          .join(', ');
      }
    }
  }
  return false;
};

export const addNewField = (form, fieldId, onUpdateFieldId, fieldKeys) => {
  const keys = form.getFieldValue(fieldKeys);
  const nextKeys = keys.concat(fieldId);

  onUpdateFieldId(fieldId + 1);

  form.setFieldsValue({
    [fieldKeys]: nextKeys,
  });
};

export const removeField = (form, key, fieldKeys) => {
  const keys = form.getFieldValue(fieldKeys);
  if (keys.length === 1) {
    return;
  }

  form.setFieldsValue({
    [fieldKeys]: keys.filter(k => k !== key),
  });
};



// WEBPACK FOOTER //
// ./src/utils/forms.js